import React from 'react';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './ProductHighlight.scss';
const PRODUCT_IMAGE = 'https://spotlightscdn.shiftplatform.tv/assets/spotlight_creator/podium-stars.png';
const ProductHighlight = props => {
  const {
    metadata,
    bohStyle,
    text
  } = props;
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  const boh_product_highlight_info = metadata.boh_product_highlight_info || {};
  const image = boh_product_highlight_info.image;
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const customTitle = {
    title: 'Product Highlight',
    ...text
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "product-highlight-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: customTitle,
    metadata: metadata
  }), /*#__PURE__*/React.createElement("div", {
    className: "product-highlight-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "product-highlight-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "product-highlight-info-legend"
  }, "Don't Forget to Mention"), /*#__PURE__*/React.createElement("div", {
    className: "product-highlight-info-title"
  }, boh_product_highlight_info.title)), image ? /*#__PURE__*/React.createElement("div", {
    className: "product-highlight-picture-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "product-highlight-picture",
    src: image,
    alt: "profile"
  })) : /*#__PURE__*/React.createElement("img", {
    className: "product-highlight-img",
    src: PRODUCT_IMAGE,
    alt: "celebrate"
  })), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default ProductHighlight;